import { render, staticRenderFns } from "./associatedStores.vue?vue&type=template&id=280103d8&scoped=true&"
import script from "./associatedStores.vue?vue&type=script&lang=js&"
export * from "./associatedStores.vue?vue&type=script&lang=js&"
import style0 from "./associatedStores.vue?vue&type=style&index=0&id=280103d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280103d8",
  null
  
)

export default component.exports
import {QScrollArea,QSelect} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QScrollArea,QSelect})
